export const transform = (values: any) => {
  delete values.recording

  return values
}
